module.exports = __webpack_public_path__ + "media/images/device-status-icon-63b58f499fe83dad045bdf0026d7f669.png";